import {SvgIconProps} from '@ui/icons/svg-icon';
import {
  FolderIcon,
  MonitorCogIcon,
  SettingsIcon,
} from 'lucide-react';
import {ReactElement} from 'react';

export const authDropdownIcons: Record<string, ReactElement<SvgIconProps>> = {
  '/admin': <MonitorCogIcon />,
  '/admin/reports': <MonitorCogIcon />,
  '/account-settings': <SettingsIcon />,
  '/drive': <FolderIcon />,
};
